export default __webpack_public_path__ + "static/media/cookie_king--dark.29a3656d.svg";